export var PortfolioRevertMode;
(function (PortfolioRevertMode) {
    PortfolioRevertMode[PortfolioRevertMode["REVERT"] = 0] = "REVERT";
    PortfolioRevertMode[PortfolioRevertMode["CLOSE_TAB"] = 1] = "CLOSE_TAB";
})(PortfolioRevertMode || (PortfolioRevertMode = {}));
